
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_1r8cv_145",
  "input": "awsui_input_1sdq3_1r8cv_180",
  "results": "awsui_results_1sdq3_1r8cv_184"
};
  